<template>
  <!-- 商品列表 -->
  <div class="list">
    <div :id="`${item.num_iid}`" :index="index" class="goods-item word-search-goods-item"
      v-for="(item, index) in $props.goodsList" :key="index">
      <a class="item-link" @click.prevent="handleClickTo($event, item, index)" :href="getLink(item)" target="_blank">
        <div class="goods-img">
          <img :src="item.pic_path" referrerpolicy="no-referrer" alt="goods image" />
        </div>
        <div class="goods-info">
          <p class="goods-title">
            {{ item[subjectKey] }}
          </p>
          <p class="goods-price">
            <span>
              {{ userStore.currencyUnit }}
              {{ $flatRateOrigin(item.price, userStore.rate) }}
            </span>
          </p>
          <div class="goods-shop-name ellipsis">
            {{ item.storeName || item.seller_nick }}
          </div>
        </div>
      </a>
    </div>
  </div>
</template>
<script setup>
import { useUserStore } from '@/stores'
import { computed, defineEmits, defineProps } from 'vue'

const userStore = useUserStore()
const subjectKey = computed(() => {
  return 'subject'
})
const $emit = defineEmits(['goToDetail'])
const $props = defineProps({
  goodsList: {
    type: Array,
    default: () => [],
  },
  showQc: {
    type: Boolean,
    default: false,
  },
  refName: {
    type: String,
    default: 'goodsList',
  },
})
const getLink = (item) => {
  return `/product?id=${item.item_id}&source=${item.source}`
}
const handleClickTo = (e, item, index) => {
  if (e && e.target && e.target.dataset && e.target.dataset.preventLink) {
    return
  }
  $emit('goToDetail', {
    id: item.num_iid,
    pos: index,
  })
  window.open(getLink(item), '_blank')
}
</script>

<style lang="scss" scoped>
// @import "@/init/base.scss";

.list {
  display: flex;
  text-align: left;
  // margin-left: -10px;
  // clear: both;
  // zoom: 1;
  min-height: 500px;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  // margin-top: 24px;

  .goods-item {
    // float: left;
    vertical-align: top;
    display: inline-block;
    // margin-right: 15px;
    transition-duration: 0.1s;
    width: 248px;

    &:nth-of-type(4n + 1) {
      margin-right: 0;
    }

    // &:hover {
    //   transform: translateY(-4px);
    // }

    // width: 224px;
    .goods-qc-list {
      height: 35px;
      margin-top: 5px;

      .goods-qc-item {
        width: 35px;
        height: 35px;
        margin-right: 12px;

        &:last-child {
          margin-right: 0px;
        }
      }
    }
  }

  // &:before,
  // &:after {
  //   content: ' ';
  //   display: table;
  // }
}

.item-link {
  border-radius: 8px;
  position: relative;
  text-decoration: none;
  display: block;
  // width: 248px;
  // padding: 10px;
  background: var(--white-color-1);
  cursor: pointer;
  box-sizing: border-box;
  text-align: left;

  &:hover {
    // border-radius: 8px;
    // z-index: 4;
    // box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  }

  .goods-img {
    box-sizing: border-box;
    width: 248px;
    height: 248px;
    background: var(--white-color-1);
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-around;

    img {
      width: 248px;
      height: 248px;
      border-style: none;
      border-radius: 8px;
    }
  }

  .goods-info {
    width: 248px;

    .goods-title {
      width: 248px;
      margin-top: 24px;
      height: 34px;
      overflow: hidden;
      color: var(--black-color-9);
      line-height: 17px;
      font-size: 14px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden; //溢出内容隐藏
      text-overflow: ellipsis; //文本溢出部分用省略号表示
      display: -webkit-box; //特别显示模式
      -webkit-line-clamp: 2; //行数
      line-clamp: 2;
      -webkit-box-orient: vertical; //盒子中内容竖直排
    }

    .goods-shop-name {
      height: 17px;
      margin-top: 4px;
      overflow: hidden;
      color: #999;
      line-height: 17px;
      font-size: 12px;
    }

    .goods-title-name {
      height: 20px;
      overflow: hidden;
      color: #333;
      line-height: 20px;
      font-size: 12px;
    }

    img {
      width: 16px;
      height: 16px;
      background-repeat: no-repeat;
      background-size: contain;
      float: left;
      margin-right: 4px;
      margin-top: 4px;
    }

    .goods-price {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 16px;
      font-weight: bold;
      font-size: 16px;
      // height: 30px;
      // padding-top: 3px;
      flex-wrap: wrap;
      overflow: hidden;
      font-family: Montserrat;
      color: var(--black-color-9);

      em {
        display: inline-block;
        font-size: 18px;
        color: #333;
        font-weight: bold;
        line-height: 24px;
        white-space: nowrap;
      }
    }
  }
}

.switch-qc-getQc {
  display: flex;
  align-self: start;
}

.switch-qc {
  margin: 0px 10px;
  width: 28px;
  height: 16px;

  ::v-deep {
    .el-switch__core {
      width: 28px !important;
      height: 16px;

      &::after {
        width: 12px;
        height: 12px;
      }
    }
  }

  &.el-switch.is-checked {
    ::v-deep {
      .el-switch__core::after {
        margin-left: -14px !important;
      }
    }
  }
}

.goods-product-img {
  width: 14px;
  height: 14px;
  margin-left: 0px !important;
  margin-right: 4px;
  vertical-align: top;
}

.no-data {
  text-align: center;
}

.pd-preview-img-qc {
  height: 0px !important;
  width: 0px !important;
}

.no-more {
  text-align: center;
  color: #999999;
  font-size: 12px;
  margin: 10px 0px;
}
</style>
